import { useState } from "react";
import { useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import BtnLoader from "../Loader/BtnLoader";
import ReactQuill from "react-quill";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { CreateAgencyBasicInfoApi } from "../../../services/apis/Agency";
import { FaArrowLeft, FaEye, FaEyeSlash } from "react-icons/fa";
import Swal from "sweetalert2";

const BasicInformation = ({ setAgencyId, setTabValue }) => {
  const [inputData, setInputData] = useState({
    company_name: "",
    profile_picture: null,
    firstname: "",
    lastname: "",
    designation: "",
    email: "",
    phone: "",
    alternate_phone: "",
    web_url: "",
    description: "",
    password: "",
    confirm_password: "",
  });
  const [btnLoading, setBtnLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState({
    password: false,
    confirm_password: false,
  });

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInputData({ ...inputData, [name]: value });
    // validateField(name, value);
  };

  // Handle file input change
  const handleFileChange = (e) => {
    setInputData({ ...inputData, profile_picture: e.target.files[0] });
  };

  const validate = () => {
    const newErrors = {};
    if (!inputData?.company_name?.trim())
      newErrors.company_name = "Company Name is required.";

    if (!inputData?.firstname?.trim())
      newErrors.firstname = "Person First Name is required.";

    if (!inputData?.lastname?.trim())
      newErrors.lastname = "Person Last Name is required.";

    if (!inputData?.phone) newErrors.phone = "Phone number is required.";

    if (!inputData.email) {
      newErrors.email = "Email is required";
    } else if (!inputData?.email?.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
      newErrors.email = "Invalid email.";
    }

    if (!inputData.password) {
      newErrors.password = "New password is required";
    } else if (inputData.password.length < 8) {
      newErrors.password = "Password must be at least 8 characters long";
    } else if (
      !inputData.password.match(/^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z\d]+$/)
    ) {
      newErrors.password =
        "Password must contain at least 1 letter and 1 number.";
    }

    if (inputData.password !== inputData.confirm_password) {
      newErrors.confirm_password = "Passwords do not match";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      setBtnLoading(true);
      const { confirm_password, ...dataToSend } = inputData;
      try {
        const response = await CreateAgencyBasicInfoApi(dataToSend);
        const resData = response?.data;
        // Simulate API request
        if (resData?.success) {
          setAgencyId(resData?.data?._id)
            Swal.fire({
              icon: "success",
              title: "Agency",
              text: resData?.message,
            });
          toast.success(resData?.message);
          setInputData({
            company_name: "",
            profile_picture: null,
            firstname: "",
            lastname: "",
            designation: "",
            email: "",
            phone: "",
            alternate_phone: "",
            web_url: "",
            description: "",
            password: "",
            confirm_password: "",
          });
          setTabValue("Company-Address")
        }
      } catch (error) {
        console.log("Error", error);
        toast.error(error?.response?.data?.message);
      } finally {
        setBtnLoading(false);
      }
    }
  };

  // const handleQuillChange = (value) => {
  //   setInputData((prevState) => ({
  //     ...prevState,
  //     description: value,
  //   }));
  // };

  const handleQuillChange = (value) => {
    const text = value?.replace(/<[^>]*>?/gm, "");
    if (text?.length <= 500) {
        setInputData((prevState) => ({
        ...prevState,
        description: value,
      }));
      setErrors({
        ...errors,
        description: "",
      });
    } else {
      setErrors({
        ...errors,
        description: "Description cannot exceed 500 characters.",
      });
    }
  };

  const handlePhoneChange = (value, country) => {
    const phoneNum = value?.slice(2);
    const country_code = `${country.format.charAt(0)}${country?.dialCode}`;
    const phone = `${country_code}${phoneNum}`;
    console.log("country_code", country_code);
    setInputData({
      ...inputData,
      phone: phone,
    });
  };

  const handleAlternatePhoneChange = (value, country) => {
    const phoneNum = value?.slice(2);
    const country_code = `${country.format.charAt(0)}${country?.dialCode}`;
    const phone = `${country_code}${phoneNum}`;
    console.log("country_code", country_code);
    setInputData({
      ...inputData,
      alternate_phone: phone,
    });
  };

  const togglePasswordVisibility = (field) => {
    setShowPassword((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };
  return (
    <>
      <ToastContainer />
      <form onSubmit={handleSubmit}>
        <div className="container-fluid my-0">
          <div className="profile-card card-bx">
            <div className="">
              <h6 className="card-title">Basic Information</h6>
            </div>
            <div className="mt-4">
              <div className="mb-3 row">
                <div className="col-md-4">
                  <label className="col-form-label">
                    Company Name <span className="asterisk">*</span>
                  </label>
                  <input
                    name="company_name"
                    value={inputData.company_name}
                    onChange={handleInputChange}
                    type="text"
                    className="form-control"
                    maxLength={80}
                  />
                  {errors.company_name && (
                    <small className="text-danger">{errors.company_name}</small>
                  )}
                </div>

                <div className="col-md-4">
                  <label className="col-form-label">Company Logo</label>
                  <input
                    name="profile_picture"
                    type="file"
                    className="form-control"
                    onChange={handleFileChange}
                  />
                </div>

                <div className="col-md-4">
                  <label className="col-form-label">Designation</label>
                  <input
                    name="designation"
                    value={inputData.designation}
                    onChange={handleInputChange}
                    type="text"
                    className="form-control"
                    maxLength={80}
                  />
                  {errors.designation && (
                    <small className="text-danger">{errors.designation}</small>
                  )}
                </div>
              </div>

              <div className="mb-3 row">
                <div className="col-md-4">
                  <label className="col-form-label">
                    Person First Name<span className="asterisk">*</span>
                  </label>
                  <input
                    name="firstname"
                    value={inputData.firstname}
                    onChange={handleInputChange}
                    type="text"
                    className="form-control"
                    maxLength={80}
                  />
                  {errors.firstname && (
                    <small className="text-danger">{errors.firstname}</small>
                  )}
                </div>

                <div className="col-md-4">
                  <label className="col-form-label">
                    Person Last Name<span className="asterisk">*</span>
                  </label>
                  <input
                    name="lastname"
                    value={inputData.lastname}
                    onChange={handleInputChange}
                    type="text"
                    className="form-control"
                    maxLength={80}
                  />
                  {errors.lastname && (
                    <small className="text-danger">{errors.lastname}</small>
                  )}
                </div>
                <div className="col-md-4">
                  <label className="col-form-label">
                    Email <span className="asterisk">*</span>
                  </label>
                  <input
                    name="email"
                    value={inputData.email}
                    onChange={handleInputChange}
                    type="email"
                    className="form-control"
                    maxLength={80}
                  />
                  {errors.email && (
                    <small className="text-danger">{errors.email}</small>
                  )}
                </div>
              </div>

              <div className="mb-3 row">
                <div className="col-md-4">
                  <label className="col-form-label">Website URL</label>
                  <input
                    name="web_url"
                    value={inputData.web_url}
                    onChange={handleInputChange}
                    type="text"
                    className="form-control"
                  />
                  {errors.web_url && (
                    <small className="text-danger">{errors.web_url}</small>
                  )}
                </div>

                <div className="col-md-4">
                  <label className="col-form-label">
                    Phone Number <span className="asterisk">*</span>
                  </label>
                  <PhoneInput
                    className=""
                    inputClass="w-100"
                    country={"in"}
                    value={inputData?.phone}
                    onChange={handlePhoneChange}
                  />
                  {errors.phone && (
                    <small className="text-danger">{errors.phone}</small>
                  )}
                </div>
                <div className="col-md-4">
                  <label className="col-form-label">
                    Alternate Phone Number
                  </label>
                  <PhoneInput
                    className=""
                    inputClass="w-100"
                    country={"in"}
                    value={inputData?.alternate_phone}
                    onChange={handleAlternatePhoneChange}
                  />
                  {errors.alternate_phone && (
                    <small className="text-danger">
                      {errors.alternate_phone}
                    </small>
                  )}
                </div>
              </div>

              <div className="mb-3 row">
                <div className="col-sm-4 ">
                  <label className="col-form-label">
                    Password<span className="text-danger">*</span>
                  </label>
                  <div className="position-relative">
                    <input
                      type={showPassword?.password ? "text" : "password"}
                      name="password"
                      value={inputData?.password}
                      className="form-control"
                      placeholder="Enter New Password"
                      onChange={handleInputChange}
                    />
                    <span
                      className="password-toggle-icon"
                      onClick={() => togglePasswordVisibility("password")}
                    >
                      {showPassword.password ? (
                        <FaEyeSlash size={20} />
                      ) : (
                        <FaEye size={20} />
                      )}
                    </span>
                  </div>
                  {errors.password && (
                    <span className="text-danger fs-12">{errors.password}</span>
                  )}
                </div>

                <div className="col-sm-4 ">
                  <label className="col-form-label">
                    Confirm Password<span className="text-danger">*</span>
                  </label>
                  <div className="position-relative">
                    <input
                      type={showPassword.confirm_password ? "text" : "password"}
                      name="confirm_password"
                      value={inputData.confirm_password}
                      className="form-control"
                      placeholder="Confirm New Password"
                      onChange={handleInputChange}
                    />
                    <span
                      className="password-toggle-icon"
                      onClick={() =>
                        togglePasswordVisibility("confirm_password")
                      }>
                      {showPassword.confirm_password ? (
                        <FaEyeSlash size={20} />
                      ) : (
                        <FaEye size={20} />
                      )}
                    </span>
                  </div>
                  {errors.confirm_password && (
                    <span className="text-danger fs-12">
                      {errors.confirm_password}
                    </span>
                  )}
                </div>
              </div>

              <div className="mb-3 row">
                <div className="col-sm-12">
                  <label className="col-sm-3 col-form-label">
                    Company Description
                  </label>
                  <ReactQuill
                    value={inputData?.description}
                    onChange={handleQuillChange}
                    placeholder="Ex: House#94  Road#8  Abc City"
                  />
                  {errors.description && (
                    <small className="text-danger">{errors.description}</small>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-end gap-4">
            {/* <div className="create-event-back-btn">
              <button type="button">Back</button>
            </div> */}
            <div className="">
              <button className="btn btn-primary" type="submit">
                {btnLoading && <BtnLoader />} Save and continue
              </button>
            </div>
          </div>
        </div>
      </form>
    </>
  );
};

export default BasicInformation;
